<template>
  <div style="position: relative">
    <div class="chart_loading" v-if="loading">
      <loading marginTop='130px'></loading>
    </div>
    <div class="chart">
      <!--<h2>Top5接口攻击趋势(一周)</h2>-->
      <div id="fingerprint"></div>
      <div id="fingerprintCoord"></div>
    </div>
  </div>

</template>
<script>
import G2 from '@antv/g2'
import Loading from '../loading/loading'

export default {
  name: 'phonePortrait',
  components: { Loading },
  props: {
    data: { type: Array, required: true },
    dataCoord: { type: Array, required: true },
    loading: { type: Boolean, default: true },
    tag: { type: Boolean, default: false }
  },
  data () {
    return {
      chart: null,
      chartCoord: null
    }
  },
  mounted () {

  },
  watch: {
    data (val) {
      console.log(val)
      if (val.length > 0) {
        if (!this.chart) {
          this.chart = new G2.Chart({
            container: 'fingerprint',
            forceFit: true,
            height: 310,
            padding: [20, 150, 50, 70]
          })
          this.chartCoord = new G2.Chart({
            container: 'fingerprintCoord',
            forceFit: true,
            height: 310,
            padding: [30, 20, 50, 20]
          })
        } else {
          this.chart.clear()
          this.chartCoord.clear()
        }
        this.draw(this.chart)
        this.drawCoord(this.chartCoord)
      }
    },
    tag (val) {
      if (val) {
        this.chart.clear()
        this.chartCoord.clear()
      }
    }
  },
  methods: {

    draw (chart) {
      const valueMap = {}
      const num = {}
      if (this.data.length > 120) {
        num.tickCount = 30
      }
      chart.source(this.data, {
        value: {
          formatter: val => {
            return val
          }
        },
        date: {
          label: '日期',
          autoRotate: false,
          ...num
        }
      })
      chart.legend({
        attachLast: true
      })
      chart
        .line()
        .position('date*value')
        .color('name', ['#f47f92', '#5db1ff', '#17DB9F', '#111360'])
        .style({
          lineWidth: 2
        })
      chart
        .point()
        .position('date*value')
        .color('name', ['#f47f92', '#5db1ff', '#17DB9F', '#111360'])
        .style({
          lineWidth: 2
        }).size('name*value*date', function (name, value, date) {
          if (
            valueMap[name + 'min'] === date ||
            valueMap[name + 'max'] === date
          ) {
            return 3
          }
          return 0
        })
      chart.render()
    },
    drawCoord (chart) {
      // chart.source(this.dataCoord, {
      //   percent: {
      //     formatter: function formatter(val) {
      //       val = (val * 100).toFixed(2) + '%';
      //       return val;
      //     }
      //   }
      // });
      // chart.coord('theta');
      // chart.tooltip({
      //   showTitle: false
      // });
      // chart.intervalStack().position('percent').color('item', [ '#17DB9F', '#308FF2','#f47f92']).label('percent', {
      //   offset: -40,
      //   // autoRotate: false,
      //   textStyle: {
      //     textAlign: 'center',
      //     shadowBlur: 2,
      //     shadowColor: 'rgba(0, 0, 0, .45)'
      //   }
      // }).tooltip('item*percent', function(item, percent) {
      //   percent = (percent * 100).toFixed(2) + '%';
      //   return {
      //     name: item,
      //     value: percent
      //   };
      // }).style({
      //   lineWidth: 1,
      //   stroke: '#fff'
      // });
      // chart.render();
      chart.source(this.dataCoord, {
        percent: {
          formatter: function formatter (val) {
            val = (val * 100).toFixed(2) + '%'
            return val
          }
        }
      })
      chart.coord('theta', {
        radius: 0.55
      })
      chart.tooltip({
        showTitle: false
      })
      chart.intervalStack().position('percent').color('item', ['#f47f92', '#5db1ff', '#17DB9F', '#111360']).label('percent', {
        formatter: function formatter (val, item) {
          return val
        }
      }).tooltip('item*percent', function (item, percent) {
        percent = (percent * 100).toFixed(2) + '%'
        return {
          name: item,
          value: percent
        }
      }).style({
        lineWidth: 1,
        stroke: '#fff'
      })
      chart.render()
    }
  }
}
</script>
<style scoped>
  .chart {
    /*background: #fff;*/
    position: relative;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }

  #fingerprint {
    background: #fff;
    width: 74%;
    height: 320px;
  }

  #fingerprintCoord {
    background: #fff;
    width: 25%;
    height: 320px;
  }

  .chart_loading {
    background: rgba(255, 255, 255, .8);
    height: 370px;
    width: 100%;
    position: absolute;
    top: -43px;
    left: 0;
    z-index: 99;
  }
</style>
